import { Input } from "@drone-js/core";
import { useFormController } from "../../form/useFormController";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { DiscountLayout } from "./DiscountLayout";

const defaultValue = 30;

export const MonthlyPromotionController = () => {
    const {
        cmsData: {
            pricing: {
                monthlyPromotion,
                appliesTo28NightStaysOrLonger,
                discount,
                pleaseEnterADiscountToContinue,
                discountMustBeBetween,
            },
        },
    } = useStaticDataAtomValue();
    const { value, setValue, fieldState, ref } = useFormController("monthlyDiscount", {
        defaultValue: defaultValue,
        rules: {
            validate: {
                notEmpty: (v) => v === null || v > 0 || pleaseEnterADiscountToContinue,
                outOfRange: (v) => v === null || (v >= 2 && v <= 90) || discountMustBeBetween,
            },
        },
    });

    const handleToggle = (checked: boolean) => {
        if (!checked) setValue(null);
        else setValue(defaultValue);
    };

    const isSelected = value !== null;

    return (
        <DiscountLayout
            id="monthlyPromotion"
            title={monthlyPromotion}
            description={appliesTo28NightStaysOrLonger}
            selected={isSelected}
            onClick={handleToggle}
            toggleDataElementName="monthly-promotion-toggle"
        >
            {isSelected && (
                <Input
                    ref={ref}
                    type="number"
                    label={discount}
                    suffix="%"
                    clearLabel="Clear"
                    value={value ?? undefined}
                    onChange={(e) => setValue(e.currentTarget.value.length === 0 ? "" : Number(e.currentTarget.value))}
                    {...(fieldState.error
                        ? {
                              intent: "error",
                              helperText: fieldState.error.message,
                          }
                        : {})}
                    data-element-name="monthly-promotion-discount"
                />
            )}
        </DiscountLayout>
    );
};
